import { useTranslation, Trans } from "react-i18next";
import Pack from "./Pack";
import backgroundImg from "../img/what_it_can_do_hm.svg";
import styles from "../css/WhatItCanDoHM.module.css";
import ButtonBtn from "./buttons/ButtonBtn";
import BoxesFroSmall from "./BoxesFroSmall";
import clockIcon from "../img/banner/clock.svg";
import growIcon from "../img/banner/grow.svg";
import publishIcon from "../img/banner/publish.svg";
import userIcon from "../img/banner/user.svg";

const icons = [publishIcon, growIcon, clockIcon, userIcon];

const WhatItCanDoHM = ({ notLoggedClick }) => {
  const { t } = useTranslation();

  // Načte celý objekt "whatItCanDoHeatmaps"
  const content = t("heatmaps.whatItCanDoHeatmaps", { returnObjects: true });

  return (
    <Pack dataComponent={"what-it-can-do-heatmaps"}>
      <div className={styles.container}>
        <img className={styles.background} src={backgroundImg} alt="" />
        <div className={styles.headingSection}>
          <h2>{content.heading}</h2>
          <p>
            {
              <Trans
                i18nKey={content.attention}
                components={[<br />, <strong></strong>]}
              />
            }
          </p>
          <ButtonBtn onClick={notLoggedClick} style={{ marginInline: "auto" }}>
            {content.btn}
          </ButtonBtn>
        </div>

        {content.texts &&
          content.texts.map((text, index) => (
            <h3
              key={index}
              className={styles[`textItem${index + 1}`] || styles.textItem}
            >
              {text.replace(/<\/?0>/g, "")}
            </h3>
          ))}
      </div>
      <div className={styles.containerSmall}>
        <BoxesFroSmall content={content} bgColor={"green"} icons={icons}>
          <h2>{content.heading}</h2>
          <p style={{ marginBlock: "24px" }}>
            {<Trans i18nKey={content.attention} components={[<br />]} />}
          </p>
          <ButtonBtn
            onClick={notLoggedClick}
            style={{ marginInline: "auto", maxWidth: "500px" }}
          >
            {content.btn}
          </ButtonBtn>
        </BoxesFroSmall>
      </div>
    </Pack>
  );
};

export default WhatItCanDoHM;
